import dhamasound from "../../assets/dhama.mp3";
function changeFromPawnToDhama(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  setPlayerTurn,
  playerTurn,
  squareRef,
  squareRefPawns,
  boardDataRef,
  dhamaIndex,
  activeSound
) {
  if (currentSquareIndex < 10 && playerTurn === 2) {
    if (activeSound) {
      new Audio(dhamasound).play();
    }
    boardDataRef.current[currentSquareIndex][0] = 32;
    dhamaIndex.push([32, currentSquareIndex]);
    squareRefPawns.current[currentSquareIndex].classList.add(
      "blue-square-dhama"
    );
  } else if (currentSquareIndex > 89 && playerTurn === 1) {
    if (activeSound) {
      new Audio(dhamasound).play();
    }
    boardDataRef.current[currentSquareIndex][0] = 31;
    dhamaIndex.push([31, currentSquareIndex]);
    squareRefPawns.current[currentSquareIndex].classList.add(
      "red-square-dhama"
    );
  }
}

export default changeFromPawnToDhama;
